import { H6, SizableText, View } from 'tamagui'
import { DesignSystem } from '@/src/design-system'
import { formatDateToShortString } from '@/src/common/utils/date'

export function StatementClose({ date }: { date: Date }) {
  return (
    <DesignSystem.Card style={{ flexGrow: 1 }}>
      <View justify="space-between" flex={1}>
        <H6>{formatDateToShortString(date, { timeZone: 'UTC' })}</H6>
        <SizableText size="$3" opacity={0.75}>
          Statement Close Date
        </SizableText>
      </View>
    </DesignSystem.Card>
  )
}
